import React from 'react'
import "./error.css"
function Error() {
  return (
    <> 
        <div className="error" type="text">Looks Like You Are Lost !</div>
        <p className="Not"> Page Not Found !</p>

    </>
   
  );
}

export default Error